import tradeSellerLinks from './messages/tradeSellerLinks';
import companyLinks from './messages/companyLinks';
import visitLinks from './messages/visitLinks';
import socialLinks from './messages/socialLinks';
import legalLinks from './messages/legalLinks';
import sitemapLinks from './messages/sitemapLinks';
import appLink from './messages/appLink';
import connectLinks from './messages/connectLinks';

export {
    tradeSellerLinks,
    companyLinks,
    visitLinks,
    socialLinks,
    sitemapLinks,
    appLink,
    legalLinks,
    connectLinks,
};
